module.exports = require('./dist/dom/dom.js');
